module.exports = __webpack_public_path__ + "img/image86.4370c664.png";